import AgencyReconciliationDetailView from 'features/Agency/components/AgencyReconciliationDetailView';
import useRouter from 'hooks/useRouter';

AgencyReconciliationDetailScreen.propTypes = {};

function AgencyReconciliationDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const reconciliationId = router?.query?.reconciliationId;
  const agencyId = router?.query?.agencyId;

  return (
    <div>
      <AgencyReconciliationDetailView reconciliationId={reconciliationId} agencyId={agencyId} />
    </div>
  );
}

export default AgencyReconciliationDetailScreen;
